import { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { checkPermission } from '../utils/backoffice-roles-data'
import { useDialog } from "../hooks/useDialog"
import { FixCommissionInput } from '../components/FixCommissionInput'
import { defaultFixCommissionRuleConditions } from '../utils/commission-rules-data'

export const CommissionRuleForm = ({ data, sendToUpdate, responseMessage }) => {

    const [formData, setFormData] = useState({

        id: 0,
        name: '',
        type: "fix",
        description: '',
        scope: '',

        conditions: defaultFixCommissionRuleConditions
    })

    const dialog = useDialog()
    const changedFields = useRef(new Set())

    const handleInputChange = (e) => {

        let { target: { name, value } } = e

        if (name === "commissionPercent") value = Math.min(Number(value) / 100, 1)
        if (name === "commissionAmount") value = Number(value)

        setFormData((prev) => ({ ...prev, [name]: value }))
        changedFields.current.add(name)
    }

    const handleSave = (duplicate = false) => {

        let copy = JSON.parse(JSON.stringify(formData))
        let dataToSend = {}

        for (const changedField of changedFields.current) {
            dataToSend[changedField] = copy[changedField]
        }

        //clean conditions object
        let conditionsSize = 0
        dataToSend.conditions = Object.keys(formData.conditions).reduce((acc, currentKey) => {

            const value = formData.conditions[currentKey]

            if (!value) return acc
            if (Array.isArray(value) && value.length === 0) return acc
            if (typeof value === 'object' && !Object.values(value).some(Boolean)) return acc

            acc[currentKey] = value
            conditionsSize += 1
            return acc
        }, {})

        if (formData.id === 0 && !formData.scope) {
            dialog.open('alert', { message: "El Alcance de la CommisionRule está sin definir" })
            return
        }
        if (conditionsSize === 0) {
            dialog.open('alert', { message: "no se puede crear una CommissionRule sin condiciones" })
            return
        }

        sendToUpdate(dataToSend, duplicate)
        // console.log(dataToSend)
    }

    const handleDelete = async () => {
        dialog.open('confirm', {
            message: '¿Estás seguro de que quieres borrar esta regla de precio?',
            callback: async () => {
                if (formData.id > 0) {
                    await sendToUpdate({ id: formData.id, venueId: 1, forceDelete: true })
                }
                window.location.href = '/price-rules'
            }
        })
    }

    useEffect(() => {
        if (data.id > 0) {

            setFormData(prev => ({
                ...data,
                conditions: {
                    ...prev.conditions,
                    ...data.conditions
                }
            }))
        }
    }, [data])

    return (

        <form className='commission-rule-form'>
            <div>
                    <div className="input-group">
                        <div>
                            <p className="label">Id</p>
                            <input type="text" className="form-control" id="price-rule-id" placeholder="Id" value={formData.id} disabled onChange={() => {/* prevents the error trigger */ }} />
                        </div>
                        <div>
                            <p className='label'>Reservas no comisionables x hora</p>
                            <input
                                type='text' 
                                id="cr-c-ncbph" 
                                className='form-control' 
                                name='conditions.noCommissionableBookingsPerHour' 
                                value={formData.conditions.noCommissionableBookingsPerHour} 
                                onChange={handleInputChange} 
                            />
                        </div>
                        <div>
                            <p className='label'>% comisionado de la base</p>
                            <input
                                type='text' 
                                id="cr-c-poca" 
                                className='form-control' 
                                name='conditions.percentageOfCommisionableAmount' 
                                value={formData.conditions.percentageOfCommisionableAmount} 
                                onChange={handleInputChange} 
                            />
                        </div>
                    </div>
                    <div className='input-group input-group-column'>
                        <FixCommissionInput 
                            name={"origin"}
                            title={"Origen"}
                            value={formData.conditions.origin}
                            onChange={() => {}}
                        />
                        <FixCommissionInput 
                            name={"creationDay"}
                            title={"Día de creación"}
                            value={formData.conditions.creationDay}
                            onChange={() => {}}
                        />
                        <FixCommissionInput 
                            name={"venue"}
                            title={"Tablao"}
                            value={formData.conditions.venue}
                            onChange={() => {}}
                        />
                        <FixCommissionInput 
                            name={"shift"}
                            title={"Turno"}
                            value={formData.conditions.shift}
                            onChange={() => {}}
                        />
                        <FixCommissionInput 
                            name={"eventShift"}
                            title={"Pase"}
                            value={formData.conditions.eventShift}
                            onChange={() => {}}
                        />
                    </div>
            </div>


            {formData.id > 0 && (
                <div className='update_info'>
                    Actualizado: {moment(formData.updatedAt).fromNow()} | Creado: {moment(formData.createdAt).fromNow()}
                </div>
            )}
            {checkPermission('backoffice.commissionRule.write') && (
                <button type="button" className="btn btn-danger mt-3" style={{ 'float': 'right' }} onClick={handleDelete}>
                    {formData.id === 0 ? 'Cancelar' : 'Borrar'}
                </button>
            )}
            {checkPermission('backoffice.commissionRule.write') && (
                <button type="button" className="btn rmb-btn-primary mt-3" onClick={() => handleSave(false)}>
                    {formData.id === 0 ? 'Crear' : 'Guardar'}
                </button>
            )}
            {formData.id !== 0 && checkPermission('backoffice.commissionRule.write') && (
                <button type="button" className="btn rmb-btn-secondary mt-3 ms-3" onClick={() => handleSave(true)}>
                    Duplicar
                </button>
            )}
            {responseMessage && (
                <div className="mt-4 alert alert-success" role="alert">
                    {responseMessage}
                </div>
            )}
        </form>

    )
}